import './ForgotPasswordView.css'

import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'

import { session } from '../store'

import { Button } from '../components/Button'
import { FieldError } from '../components/FieldError'
import { Form } from '../components/Form'
import { TextField } from '../components/TextField'
import { useFormFieldErrors } from '../hooks/useFormFieldErrors'

export function ForgotPasswordView() {
  const [formValue, setFormValue] = useState({ email: '' })
  const isLoading = useAtomValue(session.forgotPasswordIsLoadingAtom)
  const success = useAtomValue(session.forgotPasswordSuccessAtom)
  const requestPasswordReset = useSetAtom(session.forgotPasswordRequestAtom)
  const resetForgotPassword = useSetAtom(session.resetForgotPasswordAtom)

  const serverErrors = useFormFieldErrors(session.forgotPasswordIssuesAtom)

  useEffect(() => {
    return () => {
      resetForgotPassword()
    }
  }, [resetForgotPassword])

  const handleSubmit = () => {
    requestPasswordReset(formValue.email)
  }

  if (success) {
    return (
      <div className="forgot-password-view forgot-password-view__success">
        <h2 className="forgot-password-view__success-title">Check your email</h2>
        <p className="forgot-password-view__success-message">
          If an account exists with that email address, a password reset link has been sent. Please
          check your inbox and follow the instructions.
        </p>
        <p className="forgot-password-view__success-note">The link will expire in 15 minutes.</p>
        <Link to="/login" className="forgot-password-view__success-link">
          Return to sign in
        </Link>
      </div>
    )
  }

  return (
    <Form
      className="forgot-password-view"
      value={formValue}
      onChange={setFormValue}
      onSubmit={handleSubmit}
      flags={serverErrors}
    >
      <h2 className="forgot-password-view__title">Reset your password</h2>
      <p className="forgot-password-view__subtitle">
        Enter your email and we'll send you a reset link
      </p>

      <TextField
        name="email"
        label="Email"
        placeholder="Enter your email"
        required
        email
        disabled={isLoading}
      />
      <FieldError
        name="email"
        text={{
          required: 'Email is required',
          email: 'Please enter a valid email',
          rateLimitExceeded: 'Too many requests. Please try again in 15 minutes.',
          networkError: 'Network error. Please try again.',
        }}
      />

      <div className="forgot-password-view__actions">
        <Button type="submit" kind="primary" disabled={isLoading}>
          {isLoading ? 'Sending...' : 'Send Reset Link'}
        </Button>
        <Link to="/login" className="forgot-password-view__alt-action">
          Back to sign in
        </Link>
      </div>
    </Form>
  )
}
